import React, { useEffect } from 'react';
import { useSettings } from '../context/SettingsContext';

const Legal = () => {
    const { settings } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div style={{ paddingTop: '100px', paddingBottom: '60px', background: 'var(--color-cream)', minHeight: '100vh' }}>
            <div className="container" style={{ maxWidth: '800px', background: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
                <h1 style={{ color: 'var(--color-brown)', marginBottom: '30px', borderBottom: '2px solid var(--color-gold)', paddingBottom: '10px' }}>Mentions Légales</h1>

                <p>En vigueur au {new Date().toLocaleDateString('fr-FR')}</p>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>1. Éditeur du site</h2>
                    <p>
                        Le site internet <strong>{settings.siteName}</strong> est édité par :<br /><br />
                        <strong>Raison sociale :</strong> {settings.siteName}<br />
                        <strong>Adresse :</strong> {settings.address}<br />
                        <strong>Téléphone :</strong> {settings.phone}<br />
                        <strong>Email :</strong> {settings.email}
                    </p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>2. Directeur de la publication</h2>
                    <p>Le Directeur de la publication est le représentant légal de {settings.siteName}.</p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>3. Propriété intellectuelle</h2>
                    <p>
                        L'ensemble du contenu de ce site (textes, images, vidéos, et autres médias) est la propriété exclusive de <strong>{settings.siteName}</strong>.
                        Toute reproduction, distribution, modification, ou utilisation partielle ou totale de ces éléments, sans autorisation expresse et préalable, est strictement interdite.
                    </p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>4. Données personnelles</h2>
                    <p>
                        Conformément à la réglementation en vigueur (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition
                        aux données personnelles vous concernant. Pour exercer ce droit, vous pouvez nous contacter via : <strong>{settings.email}</strong>.
                    </p>
                    <p>Pour plus d'informations, veuillez consulter notre Politique de Confidentialité.</p>
                </section>

                <section style={{ marginTop: '30px' }}>
                    <h2 style={{ color: 'var(--color-brown)', fontSize: '1.4rem' }}>5. Litiges</h2>
                    <p>
                        Les présentes conditions du site sont régies par les lois françaises et tout litige ou contentieux qui pourrait naître de l'interprétation
                        ou de l'exécution de celles-ci sera de la compétence exclusive des tribunaux dont dépend le siège social de la société.
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Legal;
